import mailVistaLogo from "@/assets/icons/mailvista-logo.svg";
import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import UserProfile from "@/domain/entities/user/UserProfile";
import routes from "@/router/routes";
import { useNavigate } from "react-router-dom";
import SettingsDialog from "../settings/SettingsDialog";
import UserAvatar from "../UserAvatar";

type SelectLicenseHeaderProps = {
    user: UserProfile;
};

const SelectLicenseHeader = ({ user }: SelectLicenseHeaderProps) => {
    const navigate = useNavigate();

    return (
        <header className="z-modal-backdrop flex w-screen items-center justify-between px-12 py-6">
            <button
                className="mb-5 h-9 md:mb-0"
                onClick={() => {
                    navigate(routes.dashboard);
                }}
                type="button"
            >
                <img alt="Mailvista Logo" src={mailVistaLogo} />
            </button>
            <div className="flex items-center gap-4">
                <LogoutEscapeLink variant="pillLight" />
                <SettingsDialog trigger={<UserAvatar user={user} />} />
            </div>
        </header>
    );
};

export default SelectLicenseHeader;
